import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  boxInformation: {
    height: '100%',
  },
  chart: {
    height: '350px',
  },
}));
